import { ROUTE_CHANGE } from '../constants/general'

const handleRouteChange = (url: string) => ({
  type: ROUTE_CHANGE,
  url
})

export { handleRouteChange }
